const STORAGE_KEY = 'tracking-system-user-preferences-v1';

const normalizeEmail = (email) => String(email || '').trim().toLowerCase();

const readStore = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    console.error('Unable to read saved user preferences:', error);
    return {};
  }
};

const writeStore = (store) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (error) {
    console.error('Unable to save user preferences:', error);
  }
};

export const getUserPreferences = (email) => {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) {
    return {};
  }

  const store = readStore();
  const preferences = store[normalizedEmail];
  return preferences && typeof preferences === 'object' ? preferences : {};
};

export const setUserPreferences = (email, updates) => {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail || !updates || typeof updates !== 'object') {
    return {};
  }

  const store = readStore();
  const nextPreferences = {
    ...(store[normalizedEmail] || {}),
    ...updates,
  };

  store[normalizedEmail] = nextPreferences;
  writeStore(store);
  return nextPreferences;
};
